/** Shared emoji grid for à la carte catalog icon picker (CRM). */
export const POPULAR_EMOJIS = [
  '🚀', '⚡', '🔥', '💡', '🎯', '📈', '🔄', '⚙️', '🎨', '📱',
  '💻', '🌐', '📊', '🎪', '🏆', '💎', '🌟', '🎭', '🎪', '🎨',
  '📝', '📋', '📅', '⏰', '🔔', '📧', '💬', '📞', '📹', '🎵',
  '🛒', '💰', '💳', '📦', '🚚', '🏢', '👥', '👤', '🎓', '🔐',
  '🔍', '📌', '📍', '🎯', '🎪', '🎭', '🎨', '📚', '📖', '✏️',
  '📐', '🧮', '🔬', '🧪', '🔭', '📡', '🛰️', '🚁', '🚗', '🚲',
  '⛵', '✈️', '🚅', '🚇', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒',
  '🚐', '🚚', '🚛', '🚜', '🏍️', '🛵', '🚲', '🛴', '🛹', '🛼',
  '🚁', '🛸', '🚀', '🛶', '⛵', '🚤', '🛥️', '🛳️', '⛴️', '🚢',
  '🎡', '🎢', '🎠', '🎪', '🎭', '🎨', '🎬', '🎤', '🎧', '🎼',
  '🎹', '🥁', '🎷', '🎺', '🎸', '🪕', '🪘', '🎻', '🎲', '♟️',
  '🎯', '🎳', '🎮', '🎰', '🧩', '🎨', '📱', '💻', '⌨️', '🖥️',
  '🖨️', '🖱️', '🖲️', '💽', '💾', '💿', '📀', '📼', '📷', '📸',
  '📹', '📺', '📻', '📟', '📠', '📞', '📱', '📲', '☎️', '📞',
  '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🧭', '⏱️', '⏲️',
  '⏰', '🕰️', '⌛', '⏳', '📡', '🔋', '🔌', '💡', '🔦', '🕯️',
  '🪔', '🧯', '🛢️', '💸', '💵', '🪙', '💰', '💳', '💎', '⚖️',
  '🪜', '🦯', '🦽', '🦼', '🛹', '🛼', '🚲', '🛴', '🛵', '🏍️',
  '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋',
  '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊', '🚉',
  '✈️', '🛫', '🛬', '🛩️', '💺', '🛰️', '🚀', '🛸', '🚁', '🛶',
  '⛵', '🚤', '🛥️', '🛳️', '⛴️', '🚢', '🎡', '🎢', '🎠', '🎪',
  '🎭', '🎨', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🎷', '🎺',
  '🎸', '🪕', '🪘', '🎻', '🎲', '♟️', '🎯', '🎳', '🎮', '🎰',
  '🧩', '🎨', '📱', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '💽',
  '💾', '💿', '📀', '📼', '📷', '📸', '📹', '📺', '📻', '📟',
  '📠', '📞', '📱', '📲', '☎️', '📞', '📟', '📠', '📺', '📻',
  '🎙️', '🎚️', '🎛️', '🧭', '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳',
  '📡', '🔋', '🔌', '💡', '🔦', '🕯️', '🪔', '🧯', '🛢️', '💸',
  '💵', '🪙', '💰', '💳', '💎', '⚖️', '🪜', '🦯', '🦽', '🦼',
  '🤖', '🧠', '🔧', '🔨', '🛠️', '📊', '📈', '📉', '📋', '✅',
  '❌', '⚠️', 'ℹ️', '🔵', '🟢', '🟡', '🟠', '🔴', '🟣', '⚫',
  '⚪', '🟤', '🔄', '🔄', '⏭️', '⏮️', '⏸️', '⏹️', '⏺️', '🔀',
  '🔁', '🔂', '⏩', '⏪', '⏫', '⏬', '◀️', '▶️', '🔼', '🔽',
  '➡️', '⬅️', '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '↕️', '↔️',
  '🔄', '↩️', '↪️', '⤴️', '⤵️', '🔃', '🔄', '🔙', '🔚', '🔛',
  '🔜', '🔝', '🔞', '🔟', '🔢', '🔣', '🔤', '🔡', '🔠', '🔤',
  '🔡', '🔠', '🔤', '🔡', '🔠', '🔤', '🔡', '', '🔤', '🔡',
];
